import { TOOLBAR_BUTTON_SX } from "@/controls/buttons/toolbarButton";
import { ResetFiltersButton } from "@/controls/buttons/ResetFiltersButton";
import { Box, Button, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { ShowOnlyActivesCheckbox } from "@/controls/filters/ShowOnlyActivesCheckbox";

interface PassTypesToolbarProps {
	search: string;
	onSearchChange: (value: string) => void;
	onlyActives: boolean;
	onOnlyActivesChange: (value: boolean) => void;
	onAdd: () => void;
	onReset: () => void;
	canReset: boolean;
}

export const PassTypesToolbar = ({
	search,
	onSearchChange,
	onlyActives,
	onOnlyActivesChange,
	onAdd,
	onReset,
	canReset,
}: PassTypesToolbarProps) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1,
				flexWrap: "wrap",
				px: 1.5,
				py: 0.75,
			}}
		>
			<TextField
				size="small"
				placeholder="Search..."
				value={search}
				onChange={(e) => onSearchChange(e.target.value)}
				sx={{ width: 200 }}
			/>

			<ShowOnlyActivesCheckbox
				checked={onlyActives}
				onChange={onOnlyActivesChange}
			/>

			<ResetFiltersButton onClick={onReset} disabled={!canReset} />

			<Box sx={{ flex: 1 }} />

			<Button
				variant="contained"
				color="primary"
				startIcon={<AddIcon />}
				onClick={onAdd}
				size="medium"
				sx={TOOLBAR_BUTTON_SX}
			>
				Add Pass Type
			</Button>
		</Box>
	);
};
